import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    var GradeOptions = computed(function () {
      var _a, _b, _c;
      if ((_b = (_a = applyService.item.regConfig) === null || _a === void 0 ? void 0 : _a.gradeInfoList) === null || _b === void 0 ? void 0 : _b.length) {
        return (_c = applyService.item.regConfig) === null || _c === void 0 ? void 0 : _c.gradeInfoList.map(function (el) {
          return {
            value: el.gradeId,
            label: el.gradeName
          };
        });
      }
      return [];
    });
    return function (_ctx, _cache) {
      var _component_a_select = _resolveComponent("a-select");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfGrade.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "所在年级：",
            name: "grade"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_select, {
                allowClear: "",
                size: "large",
                value: _unref(formState).grade,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).grade = $event;
                }),
                options: _unref(GradeOptions),
                placeholder: "所在年级"
              }, null, 8, ["value", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});